// src/pages/Estoque.js

import React from "react";
import AdminLayout from "../components/AdminLayout";
import DataTableEstoque from "../components/DataTableEstoque";

function Estoque() {
  
  return (
    <AdminLayout>
      <DataTableEstoque title="Estoque" verEstoque="./atual" verItens="./itens" novaEntrada="./novo" novaSaida="./saida" />
    </AdminLayout>
  );
}

export default Estoque;